import { accounts } from "./ledger/accounts";
import { auditLogs } from "./reports/audit-logs";
import { badges } from "./growth/badges";
import { banking } from "./banking/banking";
import { billing } from "./billing/billing";
import { bookings } from "./ledger/bookings";
import { boosts } from "./growth/boosts";
import { disputes } from "./banking/disputes";
import { expenses } from "./ledger/expenses";
import { fees } from "./ledger/fees";
import { fiscalYears } from "./billing/fiscal-years";
import { invoices } from "./ledger/invoices";
import { payments } from "./ledger/payments";
import { plan } from "./billing/plan";
import { reminders } from "./banking/reminders";
import { reports } from "./reports/reports";
import { stripe } from "./billing/stripe";

export const financeApi = {
	invoices,
	payments,
	plan,
	fees,
	stripe,
	billing,
	accounts,
	bookings,
	expenses,
	reports,
	fiscalYears,
	banking,
	boosts,
	badges,
	disputes,
	reminders,
	auditLogs,
};
